<template>
  <div class="home inner-page inner-page--synak-intro">
    <!--~~~~~     PAGE HEADER     ~~~~~-->
    <header class="inner-page__header">

      <div class="container">

        <div class="row  justify-content-between  align-items-center">

          <div class="inner-page__logo  col">
            <div class="logo">
              <a class="logo__link" href="javascript:void(0)">
                <img src="@/assets/img/logo__ekyzmat-full--light.svg" alt="EKYZMAT">
                <span class="logo__descr">{{ getTranslation('testing') }}</span>
              </a>
            </div>
          </div>


          <div class="inner-page__right">
            <div class="inner-page__lang">
              <ul v-if="$store.getters['language/getLocales'].length > 0" class="lang-switcher">
                <li v-for="locale in $store.getters['language/getLocales']" class="lang-switcher__item">
                                  <span :title="$lang.app[locale.title]">
                                    <a @click="changeLocale(locale.title)" class="lang-switcher__link" :class="{'lang-switcher__link--active': locale.title === currentLocale }" href="javascript:void(0)">
                                        {{ $lang.locale[locale.title] }}
                                    </a>
                                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /row -->

      </div>
      <!-- /container -->

    </header>
    <!--~~~~~     / PAGE HEADER     ~~~~~-->
    <!--~~~~~     PAGE CONTENT     ~~~~~-->
    <main class="inner-page__content">

      <div class="container">

        <div class="inner-page__intro-heading">
          <h1 class="inner-page__title">{{ getTranslation('testing') }}</h1>
          <div class="inner-page__descr">{{ getTranslation('appDescription') }}</div>
          <a :class="'btn  btn--lg  btn--main  mb-0'" href="javascript:void(0)" @click="gotoTesting">{{ getTranslation('gotoTesting') }}</a>
        </div>

      </div>
      <!-- /container -->

    </main>
    <!--~~~~~     / PAGE CONTENT     ~~~~~-->

    <!--~~~~~     PAGE FOOTER     ~~~~~-->
    <footer class="page-footer  page-footer--transparent">

      <div class="container">
        <div class="page-footer__copyright">
          Разработчик: <a href="https://infocom.kg/">Государственное предприятие «Инфоком»</a> <br>
          © Зарегистрирован в Государственном реестре программ для ЭВМ Кыргызской Республики от 26.09.2018 года, сертификат за № 525
        </div>
      </div>
      <!-- /container -->

    </footer>
    <!--~~~~~     / PAGE FOOTER     ~~~~~-->
  </div>
</template>

<script>

export default {
  name: 'home',
  methods: {
    gotoTesting() {
      this.axios.post(this.$config.urls.candidateAuth.login.url, {pin: '99999999999999', token: '123456', lang: this.currentLocale})
          .then(response => {

            this.setCandidateToken(response.data.data.token);

            if (response.data.data.accessToken)
              this.setAccessToken(response.data.data.accessToken);
            else
              this.setAccessToken(null);

            this.setCandidateAxiosHeader();

            this.storeCandidate(response.data.data).then(() => {
              this.$router.push({name: 'auth.success'}).catch(() => {
              });
            });
          }).catch(() => {
      });
    }
  }
}

</script>
